import type { TableColumnSort } from '@ipfabric/utils';

export const getPathInspectorTableSort = (
  table: string,
): TableColumnSort | undefined => {
  switch (table) {
    case 'vRoute':
      return {
        column: 'prefix',
        order: 'desc',
      };
    case 'vMulticastRoute':
      return {
        column: 'sourceNet',
        order: 'desc',
      };
    default:
      return undefined;
  }
};
